import {
  Stack,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Button,
  Tab,
  Tabs,
  Box,
} from "@mui/material";
import { ExpandMore } from "@mui/icons-material";

import "../../../PrimeiraConsulta/modulos/styles.css";
import { ReactComponent as IconDocument } from "../../../../images/iconDocument.svg";
import { ReactComponent as IconSecurity } from "../../../../images/iconSecurity.svg";

import TableGridData from "../../../../components/TableGridData";

import OutrosExames from "../../../PrimeiraConsulta/modulos/Examesprocedimentos/Tab/OutrosExames";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ padding: "16px 0px" }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function ExamesProcedimentos({
  data,
  handleOpenDetalhesExames,
  small,
  examesOutros,
  onChangeTab,
  tabValue,
}) {
  const colunasExames = [
    {
      field: "tipo",
      headerName: "Exame",
      flex: 1,
      minWidth: 130,
    },
    {
      field: "dataCadastro",
      headerName: "Data de solicitação",
      flex: 1,
      minWidth: 190,
    },
    {
      field: "nomeCadastradoPor",
      headerName: "Profissional",
      flex: 2,
      minWidth: 250,
    },
    {
      field: "acoes",
      headerName: "Ações",
      width: 150,
      sortable: false,
      hide: true,
      description: "Ações",
      renderCell: (params) => {
        return (
          <Button
            variant="contained"
            color="primary"
            size="small"
            startIcon={<IconSecurity />}
            sx={{
              textTransform: "none",
              background: "#1E729F",
              "&:hover": { background: "#063F5E" },
            }}
            onClick={() => handleOpenDetalhesExames(params.row)}
          >
            Ver detalhes
          </Button>
        );
      },
    },
  ];

  //calcular tamanho da tabela maximo 400px
  var height = 200;
  if (data.length >= 2) {
    var test = Math.min((data.length - 1) * 50, 200);
    height += test;
  }
  return (
    <Accordion defaultExpanded={false} className="AccordionContainer">
      <AccordionSummary
        expandIcon={<ExpandMore style={{ color: "#1E729F" }} />}
        aria-controls="ExamesProcedimentos-content"
        id="ExamesProcedimentos-header"
        className={`AccordionSummaryContainer ${small ? "small" : ""}`}
      >
        <Stack direction="row" alignItems="center" gap="8px " height="30px">
          <IconDocument style={{ width: "24px" }} />
          <Typography className={`Accordion_title ${small ? "small" : ""}`}>
            Exames e procedimentos
          </Typography>
        </Stack>
      </AccordionSummary>
      <AccordionDetails>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            TabIndicatorProps={{
              style: {
                background: "#1E729F",
              },
            }}
            sx={{
              fontFamily: "Nunito",
              fontWeight: 400,
              ".Mui-selected": {
                color: "#1E729F",
                fontWeight: "700 !important",
              },
            }}
            value={tabValue}
            onChange={(e, value) => onChangeTab(value)}
            aria-label="basic tabs example"
          >
            <Tab label="Laboratorial" {...a11yProps(0)} className="tabTitle" />
            <Tab label="Outros exames" {...a11yProps(1)} className="tabTitle" />
          </Tabs>
        </Box>
        <CustomTabPanel value={tabValue} index={0}>
          <TableGridData
            rows={data}
            columns={colunasExames}
            height={`${height}px`}
          />
        </CustomTabPanel>
        <CustomTabPanel value={tabValue} index={1}>
          <OutrosExames
            onSubmit={() => {}}
            data={examesOutros}
            setData={() => {}}
            readOnly
          />
        </CustomTabPanel>
      </AccordionDetails>
    </Accordion>
  );
}
